import { Label } from '@radix-ui/react-label'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import * as React from 'react'

import { cn } from '@/lib/utils'

function RadioGroup({ className, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return <RadioGroupPrimitive.Root data-slot='radio-group' className={cn('flex flex-col gap-2', className)} {...props} />
}

function RadioGroupItem({ className, label, ...props }: React.ComponentProps<typeof RadioGroupPrimitive.Item> & { label?: string }) {
  const Container = label ? 'div' : React.Fragment
  const id = React.useId()
  return (
    <Container className='flex items-center gap-2'>
      <RadioGroupPrimitive.Item
        data-slot='radio-group-item'
        className={cn(
          'border-text-secondary data-[state=checked]:border-icon-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex size-4 shrink-0 items-center justify-center rounded-full border p-[2px] transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        id={id}
        {...props}
      >
        <RadioGroupPrimitive.Indicator
          data-slot='radio-group-indicator'
          className='bg-icon-primary flex size-full items-center justify-center rounded-full'
        />
      </RadioGroupPrimitive.Item>
      {label && (
        <Label className='text-text-primary mb-0 text-sm' htmlFor={props.id || id}>
          {label}
        </Label>
      )}
    </Container>
  )
}

export { RadioGroup, RadioGroupItem }
